import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import { FC, MouseEvent, useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { IInput, IMuiFormControl, ValidationHelpers } from "@ryde/shared";

export const InputPasswordMui: FC<IMuiFormControl & IInput> = ({
  name,
  control,
  formValidation,
  e2eData = "input-mui-password",
  size = "small",
  sx,
  tabIndex,
}) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = (): void => setShowPassword(show => !show);

  const handleMouseDownPassword = (
    event: MouseEvent<HTMLButtonElement>,
  ): void => {
    event.preventDefault();
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required:
          ValidationHelpers.hasRequiredRule(formValidation) &&
          t("errors.requiredField", { fieldName: t("general.THIS_FIELD") }),
      }}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error}>
          <OutlinedInput
            {...field}
            required={ValidationHelpers.hasRequiredRule(formValidation)}
            error={!!error}
            data-e2e={e2eData}
            fullWidth
            sx={sx}
            size={size}
            type={showPassword ? "text" : "password"}
            tabIndex={tabIndex}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          {/*TODO: add translation solution*/}
          {error && <FormHelperText>{error.message}</FormHelperText>}
          <FormHelperText>{t("login.PASSWORD_REGEX")}</FormHelperText>
        </FormControl>
      )}
    />
  );
};
